/** Постоянная времени экспоненциального сглаживания угла (сек). */
export const PLAYER_TILT_SMOOTH_SEC = 0.18;

export function smoothPlayerTilt(
  current: number,
  target: number,
  deltaSeconds: number,
  timeConstantSec = PLAYER_TILT_SMOOTH_SEC,
): number {
  if (timeConstantSec <= 0 || deltaSeconds <= 0) {
    return target;
  }
  const t = 1 - Math.exp(-deltaSeconds / timeConstantSec);
  return current + (target - current) * t;
}
